export class ModuleOutlineItem {
    ModuleId: number
    CourseId: number
    Title: string
    Ordinal: number
    AssignmentStatus: number

    constructor(init?: Partial<ModuleOutlineItem>) {
        Object.assign(this, init);
    }

    get DisplayTitle(): string {
        return this.Title.split('Module')[1].trim();
    }
}